type SkeletonVariant = 'text' | 'circle' | 'rect';

interface SkeletonProps {
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
  count?: number;
  className?: string;
}

export function Skeleton({
  variant = 'text',
  width,
  height,
  count = 1,
  className = '',
}: SkeletonProps) {
  const items = Array.from({ length: count });

  const baseClass = 'animate-pulse bg-surface-200 rounded';

  const getStyle = (): React.CSSProperties => {
    const style: React.CSSProperties = {};
    if (width) style.width = typeof width === 'number' ? `${width}px` : width;
    if (height) style.height = typeof height === 'number' ? `${height}px` : height;
    return style;
  };

  if (variant === 'circle') {
    const size = width || height || 40;
    return (
      <div className="flex gap-2">
        {items.map((_, i) => (
          <div
            key={i}
            className={`${baseClass} rounded-full ${className}`}
            style={{
              width: typeof size === 'number' ? `${size}px` : size,
              height: typeof size === 'number' ? `${size}px` : size,
            }}
          />
        ))}
      </div>
    );
  }

  if (variant === 'rect') {
    return (
      <div className="space-y-2">
        {items.map((_, i) => (
          <div
            key={i}
            className={`${baseClass} rounded-lg ${className}`}
            style={getStyle()}
          />
        ))}
      </div>
    );
  }

  // text variant
  return (
    <div className="space-y-2">
      {items.map((_, i) => (
        <div
          key={i}
          className={`${baseClass} h-4 ${className}`}
          style={{ width: width || (i === count - 1 && count > 1 ? '75%' : '100%'), ...getStyle() }}
        />
      ))}
    </div>
  );
}
